<template>
  <div></div>
</template>

<script>
export default {
  name: 'AccountReportView'
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/web/AccountReportView.vue